<template>
<div>
    <el-table ref="customTable" :data="data.filter(e => !search || JSON.stringify(e).toLowerCase().includes(search.toLowerCase())).slice((currentPage-1)*pagesize,currentPage*pagesize)" stripe border :height="height" style="width: 100%" size="mini" v-loading="loading" :element-loading-text="loadingText" element-loading-background="rgba(0, 0, 0, 0.8)" @selection-change="handleSelectionChange">
        <el-table-column v-for="(header, index) in headers" :key="index" :type="header.type" :prop="header.value" :label="header.text" :width="header.width" :sortable="header.sortable" :fixed="header.fixed" resizable :align="header.align" :header-align="header.alignHeader" :formatter="header.formatter">
            <template v-slot:default="scope" v-if="header.text === 'Actions' || header.value === 'actions'">
                <slot name="actions" v-bind:scope="scope"></slot>
            </template>

            <template v-slot:default="props" v-else-if="header.type === 'expand'">
                <slot name="expand" v-bind:props="props"></slot>
            </template>
        </el-table-column>
    </el-table>
    <div class="table-footer" v-if="!hideFooter">
        <div style="float:left;">
            <slot name="footer"></slot>
        </div>
        <el-pagination background layout="total, sizes, prev, pager, next" :total="total" :page-sizes="[100, 200, 300, 400,500]" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
    </div>

</div>
</template>

<script>
export default {
    props: {
        height: Number,
        data: Array,
        headers: Array,
        search: {
            type: [String, Number],
            default: null
        },
        expandedRow: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        loadingText: {
            type: String,
            default: 'Loading...'
        },
        total: Number,
        hideFooter: {
            type: Boolean,
            default: false
        },
        handleSelectionChange: {
            type: Function,
            default: () => {}
        },
    },
    data: () => ({
        currentPage: 1,
        pagesize: 100
    }),
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        handleSizeChange(val) {
            this.pagesize = val;
        },
        handleClearSelection() {
            this.$refs['customTable'].clearSelection();
        }
    }
}
</script>

<style>
.table-footer {
    width: 100%;
    margin-top: 10px;
}

.el-pagination {
    float: right;
}

.el-pager {
    margin-left: -25px !important;
}

.el-table .cell {
    word-break: break-word;
}
</style>
